import { render, staticRenderFns } from "./createTipoProduto.vue?vue&type=template&id=1355c6ed&scoped=true&"
import script from "./createTipoProduto.vue?vue&type=script&lang=js&"
export * from "./createTipoProduto.vue?vue&type=script&lang=js&"
import style0 from "./createTipoProduto.vue?vue&type=style&index=0&id=1355c6ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1355c6ed",
  null
  
)

export default component.exports